import { CheckIcon } from "@/assets/icons/general/Check";
import { ErrorTriangleIcon } from "@/assets/icons/general/ErrorTriangle";
import { QueuedIcon } from "@/assets/icons/general/Queued";
import { UploadingIcon } from "@/assets/icons/general/Uploading";

interface IProps {
  status: "idle" | "uploading" | "error" | "uploaded";
}

const FileUploadStatusIcon = ({ status }: IProps) => {
  const getFileStatusIcon = () => {
    switch (status) {
      case "idle":
        return <QueuedIcon className="h-4 w-4" />;
      case "uploading":
        return <UploadingIcon className="h-4 w-4" />;
      case "error":
        return <ErrorTriangleIcon className="h-4 w-4" />;
      case "uploaded":
        return <CheckIcon className="h-4 w-4" />;
      default:
        return null;
    }
  };
  return getFileStatusIcon();
};

export default FileUploadStatusIcon;
